import { Box, Tab, Tabs, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import BasicMeasureData from "./measureScreens/basicMeasureData";
import NatMeasureRegisters from "./measureScreens/NatMeasureRegisters";
import EuMeasureRegisters from "./measureScreens/EuMeasureRegister";
import PointerMeasure from "./measureScreens/pointerMeasure";
import HelpButton from "../../../common/HelpButton";
import HelpPageModal from "../../modals/HelpPageModal";
import { lockEditingStatus } from "../../../server/server";
import { useUser } from "../../../auth/UseUser";

function AddMeasure() {
  const [value, setValue] = React.useState(0);
  const [helpModal, setHelpModal] = useState(false);
  const { user } = useUser();
  const [reportLocked, setReportLocked] = useState(false);
  const closeHelpModal = () => {
    setHelpModal(false);
  };

  useEffect(() => {
    fetchCurrentStatusData();
  }, []);

  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }
  interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
  }

  function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  const fetchCurrentStatusData = async () => {
    const response = await lockEditingStatus();
    if (response.status === 200) setReportLocked(response.data.isActive);
  };

  const disabled =
    !user?.roleView?.features?.includes("administration") && reportLocked;

  return (
    <div className="py-10 px-2 overflow-auto gray-small-scroll h-full">
      <div className="flex gap-6">
        <h1 className="text-[#04438b] text-4xl font-bold">Унос мере</h1>
        <HelpButton onClick={() => setHelpModal(true)} />
      </div>
      {disabled && (
        <p className="leading-10 text-start text-errorRed">
          Унос нових мера је тренутно онемогућен, уколико желите да додате меру,
          контактирајте администратора.
        </p>
      )}
      <div className="rounded-lg border border-[#81848f3d] w-fit p-8 pb-4  mt-8 ">
        {/* <h1 className="text-[#04438bae] text-2xl font-bold">СТАЊЕ ПРЕГОВОРА</h1> */}

        <div className="flex">
          <BasicMeasureData disabled={disabled} />
        </div>
      </div>
      <HelpPageModal
        modalIsOpen={helpModal}
        closeModal={closeHelpModal}
        name={"addMeasure"}
      />
    </div>
  );
}

export default AddMeasure;
